import { Guid } from "@/types"
import Notification, { IGetNotification, NotificationType } from "./Notification"
import NotificationAsset from "./NotificationAsset"

export interface IGetNotificationAssetSplittingSucceededDto extends IGetNotification {
    notificationType: NotificationType.splitAssetSucceeded
    parent: ISplitAssetInfo
    children: ISplitAssetInfo[]
}

export interface ISplitAssetInfo {
    assetId: Guid
    referenceValuePercent: number,
    asset?:NotificationAsset
}

export default class NotificationAssetSplittingSucceeded extends Notification {
    parent: ISplitAssetInfo
    children: ISplitAssetInfo[]

    constructor(dto: IGetNotificationAssetSplittingSucceededDto) {
        super(dto)
        this.parent = {...dto.parent, asset : new NotificationAsset({assetId:dto.parent.assetId})}
        this.children = dto.children.map((dtoChildren)=>({...dtoChildren, asset: new NotificationAsset({assetId: dtoChildren.assetId})}))
    }
}
